module.exports = __webpack_public_path__ + "img/symbol_8.c71e4c4f.png";